export default __webpack_public_path__ + "static/media/Imagem7.9937e1a6.png";